var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "main-wrapper signin-form center signin-wrapper-padding" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("h3", { staticClass: "text-align-center margin-bottom-35" }, [
          _vm._v("Loading ...")
        ]),
        _vm._v(" "),
        _c("flash-message", { attrs: { autoHide: "", variant: "success" } })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "text-align-center margin-bottom-20 mm-logo" },
      [_c("img", { attrs: { src: require("@/assets/MM-logo.png") } })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c84fe998", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c84fe998","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register_confirm.vue
// module id = null
// module chunks = 